import BaseCommand from "@/models/api/commands/BaseCommand";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";

export class CopyFormOfPaymentToAllBookingItemsCommand extends BaseCommand {
  CommandName = "CopyFormOfPaymentToAllBookingItems";
  Command: {
    FormOfPaymentId: FORM_OF_PAYMENTS;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, formOfPaymentId: FORM_OF_PAYMENTS) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, FormOfPaymentId: formOfPaymentId };
  }
}
